import { AuthService } from '../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { AppMaterialModule } from '../../../../app-material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClienteService, UpdateTelegramInfoRequest } from '../../../services/cliente/cliente.service';
import { ApiResult } from '../../../models/api-result.models';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { AppGeneralsModuleslModule } from '../../../../app-generals-modules.module';
import { provideTranslocoScope, TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-telegram-info-dialog',
    standalone: true,
    imports: [CommonModule, AppGeneralsModuleslModule, AppMaterialModule, TranslocoPipe],
    providers: [...provideTranslocoScope('dialogs')],
    templateUrl: './telegram-info-dialog.component.html',
    styleUrl: './telegram-info-dialog.component.scss'
})
export class TelegramInfoDialogComponent implements OnInit {
    public form: FormGroup = new FormGroup({});
    public dados = {
        telegram_chat_id: '',
        telegram_bot_token: ''
    };
    public isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<TelegramInfoDialogComponent>,
        private formBuilder: FormBuilder,
        private clienteService: ClienteService,
        private toastrService: ToastrService,
        private authService: AuthService,
        private transloco: TranslocoService,
    ) {}

    ngOnInit(): void {
        this.criarFormulario();
        this.escutarAlteracaoDoToken();
        this.preencherComDadosSalvos();
    }

    private criarFormulario(): void {
        const chatId = this.data?.telegram_chat_id || '';
        const token = this.data?.telegram_bot_token || '';

        this.form = this.formBuilder.group({
            telegram_chat_id: [chatId, [Validators.required]],
            telegram_bot_token: [token, [Validators.required]],
        });

        this.aplicarDados(chatId, token);
    }

    private escutarAlteracaoDoToken(): void {
        this.form.get('telegram_bot_token')?.valueChanges.subscribe((token) => {
            this.dados.telegram_bot_token = token;
        });
    }

    private preencherComDadosSalvos(): void {
        const salvoNaSessao = this.lerTelegramDaSessao();
        if (salvoNaSessao) {
            this.aplicarNoFormulario(salvoNaSessao.telegram_chat_id, salvoNaSessao.telegram_bot_token);
            return;
        }

        this.preencherComDadosDoCliente();
    }

    private lerTelegramDaSessao(): { telegram_chat_id: string; telegram_bot_token: string } | null {
        const salvo = sessionStorage.getItem('telegramInfo');

        if (!salvo) {
            return null;
        }

        const telegramInfo = JSON.parse(salvo);
        return {
            telegram_chat_id: telegramInfo.telegram_chat_id ?? '',
            telegram_bot_token: telegramInfo.telegram_bot_token ?? '',
        };
    }

    private preencherComDadosDoCliente(): void {
        const cliente = this.authService.cliente;
        if (!cliente) {
            return;
        }

        if (cliente.telegram_chat_id) {
            this.dados.telegram_chat_id = cliente.telegram_chat_id;
            this.form.get('telegram_chat_id')?.setValue(cliente.telegram_chat_id);
        }

        if (cliente.telegram_bot_token) {
            this.dados.telegram_bot_token = cliente.telegram_bot_token;
            this.form.get('telegram_bot_token')?.setValue(cliente.telegram_bot_token);
        }
    }

    private aplicarNoFormulario(chatId: string, token: string): void {
        this.form.get('telegram_chat_id')?.setValue(chatId);
        this.form.get('telegram_bot_token')?.setValue(token);
        this.aplicarDados(chatId, token);
    }

    private aplicarDados(chatId: string, token: string): void {
        this.dados.telegram_chat_id = chatId;
        this.dados.telegram_bot_token = token;
    }

    fechar() {
        this.dialogRef.close();
    }

    public buscarChatID() {
        this.isLoading = true;
        this.clienteService.getChatIDFromToken(this.dados.telegram_bot_token)
            .subscribe(
                {
                    next: (resultado: any) => {
                        this.isLoading = false;

                        if (resultado && resultado.result.length > 0) {
                            const conversa = resultado.result[0];

                            this.form.get('telegram_chat_id')?.setValue(conversa.message.chat.id);
                            this.dados.telegram_chat_id = conversa.message.chat.id;
                        }
                    },
                    error: (_error: any) => {
                        this.isLoading = false;
                        this.toastrService.error(this.transloco.translate('dialogs.telegram.chatIdError'));
                    }
                }
            )
    }


    public salvar() {
        if (this.form.invalid) {
            this.toastrService.error(this.transloco.translate('dialogs.telegram.requiredFields'));
            return;
        }

        const request: UpdateTelegramInfoRequest = {
            telegram_chat_id: String(this.form.get('telegram_chat_id')?.value ?? ''),
            telegram_bot_token: String(this.form.get('telegram_bot_token')?.value ?? ''),
        };

        this.clienteService.updateTelegramInfo(request)
            .subscribe(
                {
                    next: (_apiResult: ApiResult) => {
                        this.toastrService.success(this.transloco.translate('dialogs.telegram.saveSuccess'));

                        if (this.authService.cliente) {
                            this.authService.cliente.telegram_bot_token = request.telegram_bot_token;
                            this.authService.cliente.telegram_chat_id = request.telegram_chat_id;

                            sessionStorage.setItem('telegramInfo', JSON.stringify(request));
                        }

                        setTimeout(() => {
                            this.fechar();
                        }, 1000);
                    },
                    error: (error: any) => {
                        this.toastrService.error(this.transloco.translate('dialogs.telegram.saveError'));
                    }
                }
            );
    }
}
